import { Backdrop, createStyles, alpha, makeStyles, Theme } from "@material-ui/core";
import { Spinner } from ".";
import { colors } from "swyft-react-core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: colors.white,
      backgroundColor: alpha(colors.white, 0.1)
    }
  })
);

export const Loader = () => {
  const classes = useStyles();
  return (
    <Backdrop className={classes.backdrop} open={true}>
      <Spinner />
    </Backdrop>
  );
};
